// Route Code Edited 07/13/2026
/**
 * Route T&C/Checkbox Handler
 *
 * On a captured click on Route's button/CWC, if the checkbox isn't checked,
 * block Route's default action and call window.rterms.checkout() directly (no
 * event arg) — this reuses R T&C's real validation + alert, without the isTrusted
 * short-circuit.
 */
const config = {
  selectors: {
    routeCheckout: '[data-route-cloned-button]',
    routeCWC: '[data-checkout-without-coverage-link]',
    requiredCheckboxes: ['input.rterms-checkbox']
  }
};

const { selectors } = config;
const ROUTE_BUTTON_SELECTOR = `${selectors.routeCheckout}, ${selectors.routeCWC}`;

document.addEventListener("click", (event) => {
  const clickedRouteButton = event.target.closest(ROUTE_BUTTON_SELECTOR);
  if (!clickedRouteButton) return;

  const allCheckboxesChecked = selectors.requiredCheckboxes.every(checkboxSelector => {
    const checkbox = document.querySelector(checkboxSelector);
    return checkbox?.checked ?? true;
  });

  if (allCheckboxesChecked) return;

  if (typeof window.rterms?.checkout !== "function") {
    console.error("Route checkout redirect: window.rterms.checkout unavailable, allowing checkout to proceed unvalidated.");
    return; // fail open — don't block checkout if we can't validate
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  window.rterms.checkout();
}, { capture: true });
// End Route Code